import { render, staticRenderFns } from "./PartNumberDetailsForm.vue?vue&type=template&id=0c1d4a2c"
import script from "./PartNumberDetailsForm.vue?vue&type=script&lang=js"
export * from "./PartNumberDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports